import React, { Component } from 'react';
import '../componentform.css';
import componentFormService from '../ComponentFormService.js';
import componentMap from '../../../ComponentMap';
import { showConfirmation } from '../../../ConfirmationModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faEye } from '@fortawesome/free-solid-svg-icons';
import TeamMemberForm from './TeamMemberForm';
import ComponentFormPopup from '../ComponentFormPopup';
import DnDTeamMember from './DnDTeamMember';
import FakeDnDTeamMember from './FakeDnDTeamMember';
import { showNotification } from '../../../StatusNotification';

export class TeamGridForm extends Component {
    static displayName = TeamGridForm.name;

    constructor(props) {
        super(props);
        this.state = {
            teamGrid: null,
            teamMembers: [],
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus,
            isEditOnly: this.props.isEditOnly != undefined ? this.props.isEditOnly : false,
            isInPopup: this.props.isInPopup != undefined ? this.props.isInPopup : false,
            popup: null,
            reset: false
        };
        this.displayPopup = this.displayPopup.bind(this);
        this.cancelClicked = this.cancelClicked.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.deleteTeamMember = this.deleteTeamMember.bind(this);
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newTeamGrid = this.state.teamGrid;

        newTeamGrid[e.target.name] = e.target.value;

        this.setState({ teamGrid: newTeamGrid });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let teamGrid = this.state.teamGrid;
        teamGrid.versionId = this.state.versionId;
        teamGrid.pageId = this.state.pageId;

        let url = this.state.formType == "Update" ? "UpdateTeamGrid" : "CreateTeamGrid";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(teamGrid),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    if (!this.state.isEditOnly) {
                        var pageComponentId = this.props.pageComponentId != undefined ? this.props.pageComponentId : 0;
                        var isDataSaved = componentFormService.managePageComponent(this.state.pageId, "TeamGrid", parseInt(data), parseInt(pageComponentId), this.state.versionId, this.state.versionStatus);
                    }

                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    displayPopup = (teamMemberId, formType) => {
        let popupForm = <TeamMemberForm
            componentId={teamMemberId}
            formType={formType}
            pageId={this.state.pageId}
            pageComponentId={this.props.pageComponentId}
            versionStatus={this.state.versionStatus}
            versionId={this.state.versionId}
            onComponentSaved={this.onPopupComponentSaved.bind(this)}
            isEditOnly={true}
            isInPopup={true}
            teamGridId={this.state.teamGrid.id}
        />;

        let popup = <ComponentFormPopup
            popupForm={popupForm}
            cancelClicked={this.cancelClicked.bind(this)}
        />;

        this.setState({
            popup: popup
        });
    }

    onPopupComponentSaved() {
        showNotification("Saved", "success");

        this.setState({
            reset: true,
            popup: null
        });
        this.getComponentData();
    }

    cancelClicked() {
        this.setState({
            popup: null
        });
    }

    async teamMemberOrderUpdate(componentArray) {
        let componentIdsOrdered = [];
        for (var i = 0; i < componentArray.length; i++) {
            componentIdsOrdered.push(parseInt(componentArray[i].id));
        }

        const response = await fetch('Admin/UpdateTeamMemberComponentOrder', {
            method: 'POST',
            body: JSON.stringify({ "teamMemberIds": componentIdsOrdered }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        if (data != "Saved") {
            showNotification(data, "error");
        }
    }

    async deleteTeamMember(teamMemberId) {
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteTeamMember?componentId=' + teamMemberId, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                this.setState({
                    reset: true
                });
                this.getComponentData();
            }
            else {
                showNotification(data, "error");
            }
        }
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        if (this.state.isInPopup) {
            deleteButton = null;
        }

        let componentName = null;

        if (this.state.teamGrid != null) {
            let teamGrid = this.state.teamGrid;

            componentName = teamGrid.componentName;
        }

        let mainFormClasses = "tri-grid";
        let sideMenu;
        let addNewTeamMemberButton = null;
        let teamMemberButtons = [];
        if (this.state.formType == "Update") {
            addNewTeamMemberButton = this.state.versionStatus == 'draft' ?
                <button type="button" onClick={this.displayPopup.bind(this, 0, 'Create')} className='side-menu-button'>Add Member</button> : "";

            for (var i = 0; i < this.state.teamMembers.length; i++) {
                let teamMember = this.state.teamMembers[i];

                let teamMemberKey = "teamMember" + i;

                let currentComponentManagementBtns = this.state.versionStatus == 'draft' ?
                    <>
                        <button type="button" className='current-component__edit' onClick={this.displayPopup.bind(this, teamMember.id, 'Update')} aria-label="Edit"><FontAwesomeIcon icon={faEdit} aria-hidden="true" /></button>
                        <button type="button" className='current-component__delete' onClick={this.deleteTeamMember.bind(this, teamMember.id)} aria-label="Delete"><FontAwesomeIcon icon={faTrashAlt} aria-hidden="true" /></button>
                    </> :
                    <>
                        <button type="button" className='current-component__view' onClick={this.displayPopup.bind(this, teamMember.id, 'Update')} aria-label="View"><FontAwesomeIcon icon={faEye} aria-hidden="true" /></button>
                    </>;

                let teamMemberBtnClasses = this.state.versionStatus == 'draft' ? 'sub-component-button' : 'sub-component-button disable-dnd';

                let teamMemberBtn =
                    <div key={teamMemberKey} className={teamMemberBtnClasses}>

                        {teamMember.componentName}

                        <div className='current-component__manage'>
                            {currentComponentManagementBtns}
                        </div>
                    </div>;

                teamMemberButtons.push({ id: teamMember.id.toString(), content: teamMemberBtn });
            }

            let teamMemberDnD = (this.state.versionStatus == 'draft') ?
                <DnDTeamMember items={teamMemberButtons} itemOrderUpdate={this.teamMemberOrderUpdate.bind(this)} /> :
                <FakeDnDTeamMember items={teamMemberButtons} />;

            if (this.state.reset) {
                teamMemberDnD = "";
            }

            sideMenu = <div className='side-menu' style={{ paddingRight: '2%' }}>
                {addNewTeamMemberButton}
                {teamMemberDnD}
            </div>;
        }
        else {
            mainFormClasses += " dual-grid__1-2";
        }

        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        return (
            <div className={wrapperClasses}>
                {this.state.popup}

                <form onSubmit={this.handleSubmit}>
                    <div className='dual-grid'>
                        {sideMenu}

                        <div className={mainFormClasses}>
                            <div className='tri-grid__1-3 form-title'>
                                <h2>{componentName} {componentMap.componentTypeDisplay('TeamGrid')}</h2>
                            </div>

                            <label htmlFor='teamGrid-componentName'>Component Name:</label>
                            <input id='teamGrid-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />
                            <div></div>

                            <div className='tri-grid__1-3'>
                                <button type='submit'>Save</button>
                                {deleteButton}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetTeamGrid?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            teamGrid: data.teamGrid,
            teamMembers: data.teamMembers,
            formType: formType,
            reset: false,
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteTeamGrid?componentId=' + this.state.teamGrid.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default TeamGridForm;
